import { z } from 'zod';
const deleteMissionFileParamsSchema = z.object({
    fileId: z.string().uuid(),
});
export const deleteMissionFileFunctionDef = {
    name: 'deleteMissionFile',
    requestSchema: deleteMissionFileParamsSchema,
    responseSchema: z.void(),
};
